import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function MethodSection() {
  const methodCat = categories.find((c) => c.slug === 'identification-methods');

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-4">
            科学鉴别
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            毒蘑菇测试方法
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            {methodCat?.description}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {methodCat?.articles.map((slug, index) => {
            const icons = ['ri-eye-line', 'ri-flask-line', 'ri-checkbox-blank-circle-line', 'ri-scissors-line', 'ri-windy-line', 'ri-bug-line'];
            const article = null;
            return (
              <Link
                key={slug}
                to={`/article/${slug}`}
                className="group bg-background-100 rounded-xl p-6 md:p-7 hover:bg-background-200/80 transition-all duration-300"
              >
                <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${icons[index]} text-xl text-primary-600`}></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {slug === 'visual-identification' && '外观鉴别法'}
                  {slug === 'chemical-test' && '化学反应测试法'}
                  {slug === 'spore-print' && '孢子印测试'}
                  {slug === 'cross-section' && '切面观察法'}
                  {slug === 'smell-test' && '气味辨别法'}
                  {slug === 'insect-bite-myth' && '昆虫叮咬误区'}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {slug === 'visual-identification' && '通过观察菌盖形状、颜色、菌褶排列等外观特征，初步判断蘑菇种类。'}
                  {slug === 'chemical-test' && '利用化学试剂与蘑菇组织反应，通过颜色变化科学验证蘑菇毒性。'}
                  {slug === 'spore-print' && '收集蘑菇孢子观察颜色，最简单可靠的鉴别手段之一。'}
                  {slug === 'cross-section' && '切开蘑菇观察菌肉颜色变化，某些毒蘑菇切开后迅速变色。'}
                  {slug === 'smell-test' && '不同蘑菇有独特气味，学会用嗅觉辅助鉴别，增加判断准确性。'}
                  {slug === 'insect-bite-myth' && '虫子吃过的蘑菇就安全吗？拆解这个最常见的致命误区。'}
                </p>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/identification-methods"
            className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm transition-colors"
          >
            查看全部鉴别方法
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}